import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { Form } from 'react-bootstrap';

import { LAYER_SUBTYPES, getSubTypesForType } from '../../../api/Layers/Layers';

const LayerSubTypeField = ({ layerType, layerSubType, changeLayerSubType, isFree }) => (
  <Form.Group>
    <Form.Label>Layer Subtype</Form.Label>
    <Form.Control
      as="select"
      name="layerSubType"
      value={layerSubType}
      onChange={changeLayerSubType}
    >
      <option value="">-</option>
      {map(getSubTypesForType(layerType, 'object', isFree), (value, key) => {
        return (
          <option value={value} key={value}>
            {LAYER_SUBTYPES.properties[key].humanValue}
          </option>
        );
      })}
    </Form.Control>
  </Form.Group>
);

LayerSubTypeField.propTypes = {
  changeLayerSubType: PropTypes.func.isRequired,
  layerType: PropTypes.string.isRequired,
  layerSubType: PropTypes.string.isRequired,
  isFree: PropTypes.bool.isRequired
};

export default LayerSubTypeField;
